import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100%;
  flex: 1;
  padding: 1rem;
  box-sizing: border-box;
  color: #ffffff;
  word-break: keep-all;

  p {
    line-height: 1.5rem;
  }
`;

export const TitleWrapper = styled.div`
  width: 100%;
  padding: 24px 24px 16px 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Text = styled.div`
  color: #ffffff;
  font-weight: 700;
  font-size: 15px;
  line-height: 27px;
  margin-left: 5px;
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

export const ContentsText = styled.div`
  width: 100%;
  word-break: keep-all;
  white-space: break-spaces;
`;

export const InfoText = styled.div`
  align-self: center;
  text-align: center;
  max-width: 300px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: #fff;
  word-break: keep-all;
`;
